import AncillaryUIModel from './ancillary';

class AncillaryOfferUIModel {
  constructor({
    appliesToIndividualLegs,
    appliesToIndividualPassengers,
    ancillary,
    discountPrice,
    _meta, 
  }) {
    this.discountPrice = discountPrice;
    this.appliesToIndividualLegs = appliesToIndividualLegs;
    this.appliesToIndividualPassengers = appliesToIndividualPassengers;
    this.ancillary = new AncillaryUIModel(ancillary);
    this.offerClass = _meta.class;
  }

  getGroupCode() {
    return this.ancillary.groupCode;
  }

  getType() {
    return this.ancillary.type === '029' ? 'CBX' : this.ancillary.type;
  }

  toApi(legCode, quantity) {
    return this.ancillary.toApiTravelerAncillary(legCode, quantity);
  }
}

export default AncillaryOfferUIModel;
